import { Box, Modal } from "@mui/material";
import { modalStyle } from "../../MUIStyles";
import { useMyContext } from "../../context";
import DialogsButtons from "../DialogsButtons";

const Delete = ({ title, subTitle, loading, fun }) => {
  const { modalStates, handleCloseModal, setId } = useMyContext();
  const closeModal = () => {
    setId("");
    handleCloseModal("delete");
  };
  return (
    <Modal open={modalStates.delete} onClose={closeModal}>
      <Box
        sx={{
          ...modalStyle,
          maxHeight: "90vh",
          width: { lg: "600px", xs: "400px" },
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col items-center gap-5 font-semibold">
          <h3 className="lg:text-2xl text-xl font-bold">{title}</h3>
          <p className="text-center">{subTitle}</p>
          <DialogsButtons
            Btn1="Cancel"
            Btn2={loading ? "Deleting..." : "Confirm Delete"}
            color="bg10"
            onClick={fun}
            onClose={closeModal}
            disable={loading}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default Delete;
